// extracted by mini-css-extract-plugin
module.exports = {"root":"az_JC","disabled":"az_KC","input":"az_LC","checkmark-container":"az_MC","checkmark-border":"az_NC","checkmark-box":"az_OC","checkmark":"az_PC","label-text":"az_QC"};